
import { mapState } from 'vuex'
import { authorImage } from '@/utils/constants'

import HeroButton from '@/components/HeroButton'
import ReviewStars from '@/components/ReviewStars'
import ChevronIconNoSpace from '@/static/svg/chevron-icon-nospace.svg'

export default {
  components: {
    HeroButton,
    ChevronIconNoSpace,
    ReviewStars,
  },
  props: {
    recommendations: {
      type: Array,
      default: () => [],
    },
    displayedInModal: {
      type: Boolean,
      default: false,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      carouselOptions: {
        slidesToShow: this.displayedInModal ? 2 : 4,
        infinite: false,
        lazyLoad: 'ondemand',
        arrows: true,
        variableWidth: false,
      },
      authorImage,
      addedUpsellItemsByIndex: [],
    }
  },
  computed: {
    ...mapState(['cdn']),
  },
  mounted() {
    const responsive = [
      {
        breakpoint: 374,
        settings: {
          slidesToShow: 1,
        },
      },
    ]
    const fullResponsive = [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
    ]
    if (!this.displayedInModal) {
      responsive.push(...fullResponsive)
    }

    this.carouselOptions = { ...this.carouselOptions, responsive }
  },
  methods: {
    addToBasket(item, index) {
      if (this.displayedInModal) {
        this.addedUpsellItemsByIndex.push(index)
      }
      this.$emit('added-to-basket', item)
    },
    preventDrag(event) {
      event.preventDefault()
    },
    isAddedByUpsell(index) {
      return this.addedUpsellItemsByIndex.includes(index)
    },
  },
}
